/**------------- Home constants -------------**/

/*  General  */
export const HOME_LAYOUT_CLASS_NAME = "home-layout";
export const HOME_HEADER_CLASS_NAME = "home-header";
export const HOME_CONTENT_CLASS_NAME = "home-content";
